import { render, staticRenderFns } from "./glwj.vue?vue&type=template&id=cec72c6e&scoped=true&"
import script from "./glwj.vue?vue&type=script&lang=ts&"
export * from "./glwj.vue?vue&type=script&lang=ts&"
import style0 from "./glwj.vue?vue&type=style&index=0&id=cec72c6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec72c6e",
  null
  
)

export default component.exports